import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppDataService } from 'src/app/services/app-data.service';
import { ErrorModalService } from 'src/app/services/error-modal.service';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss'],
})
export class ErrorModalComponent implements OnInit {
  isVisible = false;
  systemLanguage = new BehaviorSubject([]);
  routeId: any = '';
  constructor(public errorModal: ErrorModalService, private cd: ChangeDetectorRef, private appData: AppDataService,) {
  }

  async ngOnInit() {
    await this.appData.getSystemLanguagesData('system_languages');
    this.systemLanguage.next(this.appData.systemLanguages[0]);
    this.errorModal.onModalChnage.subscribe(val => {
      this.isVisible = val;
      this.cd.detectChanges();
    });
  }

}
